var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSolutions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 57,
    viewBox: "0 0 81 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0957 2H20.2778V21.5976H60.0957V2Z",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1865 21.5975V31.7867",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1953 31.7867V40.0788",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15771 31.7867V40.0788",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1955 31.7867H40.1865",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1862 31.7867H9.17725",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17783 54.3913C13.142 54.3913 16.3557 51.1873 16.3557 47.235C16.3557 43.2827 13.142 40.0787 9.17783 40.0787C5.21362 40.0787 2 43.2827 2 47.235C2 51.1873 5.21362 54.3913 9.17783 54.3913Z",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1954 54.3913C75.1596 54.3913 78.3732 51.1873 78.3732 47.235C78.3732 43.2827 75.1596 40.0787 71.1954 40.0787C67.2312 40.0787 64.0176 43.2827 64.0176 47.235C64.0176 51.1873 67.2312 54.3913 71.1954 54.3913Z",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1865 31.7867V40.0788",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1861 54.3913C44.1503 54.3913 47.364 51.1873 47.364 47.235C47.364 43.2827 44.1503 40.0787 40.1861 40.0787C36.2219 40.0787 33.0083 43.2827 33.0083 47.235C33.0083 51.1873 36.2219 54.3913 40.1861 54.3913Z",
    stroke: "#FF20AD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolutions);
export default __webpack_public_path__ + "static/media/icon_solutions.d12b2002476574f0bd089af2729e77b3.svg";
export { ForwardRef as ReactComponent };